import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';

@Component({
  selector: 'my-changepassword',
  templateUrl: './ChangePassword.component.html'
})
export class ChangePasswordComponent implements OnInit {

    userInfo: ent.UserInfo;
    form: FormGroup;
    changePassword: ent.ChangePasswordRequest;

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;

    @Input() public showCurrentPassword: boolean;

    constructor(fb: FormBuilder, private authenticationService: serv.AuthenticationService, private employeeService: serv.EmployeeService, private router: Router) 
    { 
        
        let group = {
            'username' : { value: '', disabled: "true" },
            'currentPassword' : '',
            'newPassword' : ''
        };
        
        this.form = fb.group(group);
        this.showCurrentPassword = true;
        

    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus()){
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        this.changePassword = {EmployeeID: this.userInfo.Employee.ID, Username: this.userInfo.Employee.Username, 
            RequireCurrentPassword: this.showCurrentPassword, SavedByEmployee: this.userInfo.Employee};

        //this.form.controls.currentPassword.setValidators(Validators.required);
        this.form.controls.newPassword.setValidators(Validators.required);
    }

    onOKClick(event: any){
        this.employeeService.changePassword(this.changePassword).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            
            this.changePassword.CurrentPassword = "";
            this.changePassword.NewPassword = "";
            this.form.markAsUntouched();
            
        });
    }

}